import { Translations } from './en';

const fr: Translations = {
  listTitle: 'Tous les workflows',
  addButton: 'Ajouter un workflow',
  lastUpdated: 'Modifié le',
};

export default fr;
